import { Tag } from 'lib-shared-legacy-types';
import _intersectionBy from 'lodash/intersectionBy';
import { PureComponent } from 'react';
import { WrappedFieldArrayProps } from 'redux-form';

import { TagsSelect } from 'fable/tagsSelect/containers/tagsSelect';

type Props = WrappedFieldArrayProps<Tag> & { disabled?: boolean };

export class TagsSelectFieldArray extends PureComponent<Props> {
  constructor(props: Props) {
    super(props);
    this.deleteTag = this.deleteTag.bind(this);
    this.addTag = this.addTag.bind(this);
  }

  deleteTag(tag: Tag) {
    const { fields } = this.props;
    const index = fields.getAll()?.findIndex((t) => t.name === tag.name);
    if (index > -1) {
      fields.remove(index);
    }
  }

  addTag(tag: Tag) {
    const { fields } = this.props;
    if (!fields.getAll()?.find((t) => t.name === tag.name)) {
      fields.push(tag);
    }
  }

  render() {
    const { fields, disabled } = this.props;

    return (
      <TagsSelect
        allowCreatingNewTag
        deselectTag={this.deleteTag}
        selectTag={this.addTag}
        selectedItems={fields.getAll() || []}
        buttonText="Tags"
        buttonProps={{ disabled }}
      />
    );
  }
}
